// SPEC-INFORME-PROPUESTA: diccionario ÚNICO enum→presentación de los motivos de colocación del solver
// (explicabilidad, auditada 14✅). Lo comparten el calendario (panel "¿Por qué?") y el Informe de
// Propuesta. SOLO presentación: nunca recalcula ni inventa motivos (ENAC: mismos datos → mismo texto).
const MOTIVOS = {
    POR_PLAZO: { texto: 'por plazo', badge: 'POR PLAZO', clase: 'b-plazo' },
    POR_URGENCIA: { texto: 'por urgencia', badge: 'POR URGENCIA', clase: 'b-urgencia' },
    POR_CERCANIA: { texto: 'por cercanía', badge: 'POR CERCANÍA', clase: 'b-cercania' },
    POR_SECUENCIA_OPTIMA: { texto: 'por secuencia óptima de ruta', badge: 'SECUENCIA ÓPTIMA', clase: 'b-secuencia' },
    CIERRE_DE_RUTA: { texto: 'cierre de ruta', badge: 'CIERRE DE RUTA', clase: 'b-cierre' },
    // Palanca A (solver v0.19): empaquetado del día — visita corta que aprovecha el hueco hasta las 8 h
    RELLENO_HUECO: { texto: 'relleno de hueco', badge: 'RELLENO DE HUECO', clase: 'b-relleno' },
    ZONA_PREFERENTE: { texto: 'zona preferente', badge: 'ZONA PREFERENTE', clase: 'b-zona' },
    HORARIO: { texto: 'por jornada/horario', badge: 'HORARIO', clase: 'b-horario' }
};

// Texto legible del motivo + detalle del solver entre paréntesis (formato del panel del calendario).
function textoMotivo(e) {
    if (!e) return '';
    const m = MOTIVOS[e.motivoColocacion];
    const base = m ? m.texto : (e.motivoColocacion || '').toLowerCase();
    return e.detalle ? base + ' (' + e.detalle + ')' : base;
}

// Clase CSS del badge del motivo (paleta categórica del mockup del informe).
function claseMotivo(motivoColocacion) {
    const m = MOTIVOS[motivoColocacion];
    return m ? m.clase : 'b-cierre';
}

// Etiqueta corta del badge.
function badgeMotivo(motivoColocacion) {
    const m = MOTIVOS[motivoColocacion];
    return m ? m.badge : (motivoColocacion || '');
}

export default { MOTIVOS, textoMotivo, claseMotivo, badgeMotivo };
export { MOTIVOS, textoMotivo, claseMotivo, badgeMotivo };
